/* Tiny level bus: real mic / playback amplitude (0..1) → orb. No React state per frame. */
const EVT = "jarvis-level";

export const emitLevel = (v) => window.dispatchEvent(new CustomEvent(EVT, { detail: Math.max(0, Math.min(1, v || 0)) }));
export const onLevel = (fn) => {
  const h = (e) => fn(e.detail);
  window.addEventListener(EVT, h);
  return () => window.removeEventListener(EVT, h);
};

/* Attach an analyser to a MediaStream (mic) or HTMLAudioElement (playback). Returns stop(). */
export const startLevelMeter = (source) => {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return () => {};
  let ctx, raf, node;
  try {
    ctx = new AC();
    const analyser = ctx.createAnalyser();
    analyser.fftSize = 512;
    if (source instanceof MediaStream) {
      node = ctx.createMediaStreamSource(source);
      node.connect(analyser);
    } else {
      node = ctx.createMediaElementSource(source);
      node.connect(analyser);
      analyser.connect(ctx.destination);
    }
    const buf = new Uint8Array(analyser.fftSize);
    const loop = () => {
      analyser.getByteTimeDomainData(buf);
      let sum = 0;
      for (let i = 0; i < buf.length; i++) { const d = (buf[i] - 128) / 128; sum += d * d; }
      emitLevel(Math.min(1, Math.sqrt(sum / buf.length) * 3.2));
      raf = requestAnimationFrame(loop);
    };
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    loop();
  } catch (e) {
    return () => {};
  }
  return () => {
    cancelAnimationFrame(raf);
    emitLevel(0);
    try { node?.disconnect(); } catch (err) {}
    if (ctx && ctx.state !== "closed") ctx.close().catch(() => {});
  };
};
